import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { PageHeader } from '@/components/page-header'
import { useSaveProduct } from '@/features/admin/products/api'
import { NEW_PRODUCT_DEFAULTS } from '@/features/admin/products/product-defaults'
import { ProductForm } from '@/features/admin/products/product-form'
import { notifySuccess } from '@/lib/notify'
import { ROUTES } from '@/lib/routes'
import { requirePermission } from '@/lib/route-guards'

export const Route = createFileRoute('/_app/admin/products/new')({
  beforeLoad: requirePermission('catalog:manage'),
  component: NewProductPage,
})

function NewProductPage() {
  const navigate = useNavigate()
  const save = useSaveProduct()
  return (
    <div className="space-y-6">
      <PageHeader eyebrow="Productos de crédito" title="Nuevo producto" description="Defina los límites que se validarán en cada solicitud." />
      <ProductForm
        initialValues={NEW_PRODUCT_DEFAULTS}
        submitLabel="Crear producto"
        onSubmit={async (values) => {
          await save.mutateAsync(values)
          notifySuccess('Producto creado')
          await navigate({ to: ROUTES.products })
        }}
      />
    </div>
  )
}
